
import { defineComponent, inject, onMounted } from 'vue';
import { CardProvider } from '@/components/ui-elements';

export default defineComponent({
	setup() {
		const { setCardContent } = inject<any>(CardProvider);
		onMounted(() => setCardContent('header'));
	},
});
